module.exports = __webpack_public_path__ + "resources/img/img_secure_center02_jp.013038393d3a9998ecaa7e07ac49f0c2.png";